import promisedWeiXin from '@@/plugin-weixin/promiseWx';
import UserTrack from '@relx/user-track';
const userTrack = UserTrack.getInstance('prd');

let hasConfig = false;

function search2obj(search: string) {
  return search
    .split('&')
    .map(s => ({ [s.split('=')[0]]: s.split('=')[1] }))
    .reduce((total, item) => ({ ...total, ...item }), {});
}

function obj2search(obj: { [props: string]: string }) {
  let str = [];
  for (const key in obj) {
    str.push(`${key}=${obj[key]}`);
  }
  return str.join('&');
}

function formatLink(link: string) {
  const href = link.split('?')[0];
  const search = link.split('?')[1];
  if (!search) {
    return `${link}?&utm_source=wx_share`;
  }
  const searchParams = search2obj(search);
  const BLACK_PARAMS = [
    'open_id',
    'tempToken',
    'utm_source',
    'utm_campaign',
    'bound',
    'thirdPartyPlatform',
    'nickName',
    'headUrl',
  ];
  BLACK_PARAMS.forEach(param => {
    delete searchParams[param];
  });
  return `${href}?${obj2search(searchParams)}&utm_source=wx_share`;
}

const share = (shareOption?: Parameters<typeof promisedWeiXin.share>[0]) => {
  const SHARE_API: (
    | 'updateAppMessageShareData'
    | 'updateTimelineShareData'
    | 'onMenuShareWeibo'
  )[] = [
    'updateAppMessageShareData',
    'updateTimelineShareData',
    'onMenuShareWeibo',
  ];
  const config = {
    title: shareOption?.title || '悦刻RELX',
    desc: shareOption?.desc || '悦刻RELX',
    link: shareOption?.link || formatLink(window.location.href),
    imgUrl:
      shareOption?.imgUrl ||
      'https://oss-static.relxtech.com/relxapi/app/filedata/2021-10-20/e0a41f60-c305-4bca-9273-242a078f613f144x144.png',
  };
  return Promise.all(SHARE_API.map(api => promisedWeiXin[api](config)));
};

function init() {
  if (!/MicroMessenger/i.test(window.navigator.userAgent)) {
    return Promise.reject('not wx env');
  }
  if (hasConfig) {
    return Promise.resolve('has configed');
  }

  return new Promise((resolve, reject) => {
    function formatReject(type: string, err: any) {
      reject(err);
      if (typeof err === 'object') {
        userTrack.log('wx_init_error', {
          ...err,
          error_type: type,
        });
        return;
      }
      if (typeof err !== 'function') {
        userTrack.log('wx_init_error', {
          error_msg: err,
          error_type: type,
        });
      }
    }
    fetch(
      `https://gatewayapi.relxtech.com/enc/ticket/get?app_id=188&url=${btoa(
        window.location.href.split('#')[0],
      )}`,
      {
        method: 'get',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      },
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        return Promise.reject(res);
      })
      .then((res) => {
        if (res.code === 0) {
          promisedWeiXin
            .config({
              ...res.data,
              debug: false,
              jsApiList: [...Object.keys(promisedWeiXin)],
            })
            .then(() => {
              hasConfig = true;
              resolve(res.data);
            })
            .catch((err) => {
              console.error('wx config error: ', err);
              formatReject('wx_config_error', err);
            });
        } else {
          formatReject('wx_biz_error', res);
        }
      })
      .catch((err) => {
        const { status, statusText, url } = err;
        formatReject('wx_http_error', { status, statusText, url });
        console.log('wx http err: ', { ...err });
      });
  });
}

export const wx = {
  ...promisedWeiXin,
  init,
  share,
};
